import { SettingsPageKind } from "client/Api/SettingsLayout/settingsLayout";
import { useEffect } from "react";
import create, { UseStore } from "zustand";
import createVanilla, { StoreApi } from "zustand/vanilla";

type SidebarMenuSelectionStoreData = {
	selectedItemId: SettingsPageKind | undefined;
	changeSelectedId: (id: SettingsPageKind | undefined) => void;
};

const sidebarMenuSelectionStore: StoreApi<SidebarMenuSelectionStoreData> = createVanilla(
	set => {
		return {
			selectedItemId: undefined,
			changeSelectedId: (id: SettingsPageKind | undefined): void => {
				set({ selectedItemId: id });
			}
		};
	}
);

export const useSidebarMenuSelectionStore: UseStore<SidebarMenuSelectionStoreData> = create(sidebarMenuSelectionStore);

export function useActiveSettingsMenuItem(id: SettingsPageKind): void {
	const changeSelectedId: (id: SettingsPageKind | undefined) => void = useSidebarMenuSelectionStore(x => x.changeSelectedId);

	useEffect(
		(): EffectWithDestructorResult => {
			changeSelectedId(id);

			return () => changeSelectedId(undefined);
		},
		[changeSelectedId, id]
	);
}